module.exports = __webpack_public_path__ + "static/awards-05-74717852b51a1b20423d624b93df5787.png";